import React from "react";

const Privacy = () => {
  return (
    <div className="p-6 text-white bg-gray-900">
      {/* <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1> */}
      <p className="mb-4">Privacy Policy for Zim Xplore</p>
      <p className="mb-4">Effective Date: September 01 2024</p>

      <h2 className="text-2xl font-semibold mb-2">1. Introduction</h2>
      <p className="mb-4">
        Welcome to Zim Xplore. We value your privacy and are committed to
        protecting your personal data. This Privacy Policy explains how we
        collect, use, and disclose information about you when you use our app.
      </p>

      <h2 className="text-2xl font-semibold mb-2">2. Information We Collect</h2>
      <ul className="list-disc list-inside mb-4">
        <li>
          <strong>Personal Information</strong>: When you create an account, we
          may collect personal information such as your name, email address,
          phone number, and profile picture.
        </li>
        <li>
          <strong>Usage Data</strong>: We collect information about how you use
          our app, such as the features you use, the actions you take, and the
          time, frequency, and duration of your activities.
        </li>
        <li>
          <strong>Device Information</strong>: We collect information about the
          device you use to access our app, including the hardware model,
          operating system and version, unique device identifiers, and mobile
          network information.
        </li>
        <li>
          <strong>Location Data</strong>: With your permission, we may collect
          information about your location.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">
        3. How We Use Your Information
      </h2>
      <ul className="list-disc list-inside mb-4">
        <li>To provide, maintain, and improve our services.</li>
        <li>
          To communicate with you, respond to your inquiries, and provide
          customer support.
        </li>
        <li>
          To personalize your experience and provide content and features that
          match your preferences.
        </li>
        <li>
          To monitor and analyze trends, usage, and activities in connection
          with our app.
        </li>
        <li>
          To detect, investigate, and prevent fraudulent transactions and other
          illegal activities.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">
        4. Sharing Your Information
      </h2>
      <ul className="list-disc list-inside mb-4">
        <li>
          We may share your information with third-party service providers who
          perform services on our behalf.
        </li>
        <li>
          We may disclose your information if required by law or if we believe
          that such action is necessary to comply with legal obligations,
          protect and defend our rights or property, or prevent fraud or other
          illegal activity.
        </li>
        <li>
          In the event of a merger, acquisition, or sale of all or a portion of
          our assets, your information may be transferred as part of the
          transaction.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">5. Your Choices</h2>
      <ul className="list-disc list-inside mb-4">
        <li>
          You can update your account information and preferences at any time in
          the app settings.
        </li>
        <li>
          You can opt out of receiving promotional communications from us by
          following the instructions in those communications.
        </li>
        <li>
          You can delete your account by contacting us at [Contact Email].
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">6. Security</h2>
      <p className="mb-4">
        We take reasonable measures to protect your personal information from
        loss, theft, misuse, and unauthorized access, disclosure, alteration,
        and destruction.
      </p>

      <h2 className="text-2xl font-semibold mb-2">7. Children’s Privacy</h2>
      <p className="mb-4">
        Our app is not intended for use by children under the age of 13, and we
        do not knowingly collect personal information from children under 13.
      </p>

      <h2 className="text-2xl font-semibold mb-2">
        8. Changes to This Privacy Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page and
        updating the effective date.
      </p>

      <h2 className="text-2xl font-semibold mb-2">9. Contact Us</h2>
      <p className="mb-4">
        If you have any questions about this Privacy Policy, please contact us
        at reedlytech@gmail.com.
      </p>
    </div>
  );
};

export default Privacy;
